<template>
  <div class="math-captcha">
    <!-- <p class="captcha-instruction">Please solve this math problem to prove you're not a robot:</p> -->
    <div class="captcha-problem">{{ num1 }} + {{ num2 }} = ?</div>
    <div class="captcha-input-group">
      <input
        v-model="userAnswer"
        type="number"
        placeholder="tu respuesta"
        required
        @input="validateAnswer"
      />
      <button
        type="button"
        @click="generateNewProblem"
        class="refresh-btn"
        aria-label="Generate new math problem"
      >
        ↻
      </button>
    </div>
    <p v-if="errorMessage" class="error-message">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
export default {
  name: "MathCaptcha",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      num1: 0,
      num2: 0,
      userAnswer: "",
      errorMessage: "",
    };
  },
  created() {
    this.generateNewProblem();
  },
  methods: {
    generateNewProblem() {
      this.num1 = Math.floor(Math.random() * 20) + 10;
      this.num2 = Math.floor(Math.random() * 10) + 1;
      this.userAnswer = "";
      this.errorMessage = "";
      this.$emit("input", false);
    },
    validateAnswer() {
      const correctAnswer = this.num1 + this.num2;
      const isCorrect = parseInt(this.userAnswer) === correctAnswer;

      if (this.userAnswer === "") {
        this.errorMessage = "";
        this.$emit("input", false);
      } else if (isCorrect) {
        this.errorMessage = "";
        this.$emit("input", true);
      } else {
        this.errorMessage =
          "Respuesta incorrecta. Por favor, inténtalo de nuevo.";
        this.$emit("input", false);
      }
    },
  },
};
</script>

<style scoped>
.math-captcha {
  margin: 1rem 0;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 4px;
}

.captcha-instruction {
  margin: 0 0 0.5rem 0;
  font-size: 0.9rem;
  color: #666;
}

.captcha-problem {
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0.5rem 0;
}

.captcha-input-group {
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
}

.captcha-input-group input {
  flex: 1;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.refresh-btn {
  margin-left: 0.5rem;
  padding: 0.5rem;
  background: #e9ecef;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.refresh-btn:hover {
  background: #dee2e6;
}

.error-message {
  margin: 0.5rem 0 0 0;
  color: #dc3545;
  font-size: 0.8rem;
}
</style>
